import { createStore } from "redux";
import {
  api,
  headers,
  getOptions,
  postOptions,
  rizevo_login_data,
} from "../common/server";
import API from "../common/Api";

let initalState = {
  rizevo_login_data,
  countries: [{ name: "Nigeria" }],
  percentageCut: ["100", "90", "80", "70", "60", "50", "40", "30", "20", "10"],
  userProfile: {},
  member: {},
  business: {},
  bookingSettings: {},
  businessCatergories: [],
  businesslocationTypes: [
    { name: "Physical Location", id: 1 },
    { name: "Online Service", id: 2 },
    { name: "Mobile Service", id: 3 },
  ],
  opening_hours: [
    "07:00",
    "07:30",
    "08:00",
    "08:30",
    "09:00",
    "09:30",
    "10:00",
    "10:30",
    "11:00",
    "11:30",
  ],
  closing_hours: [
    "12:00",
    "12:30",
    "01:00",
    "01:30",
    "02:00",
    "02:30",
    "03:00",
    "03:30",
    "04:00",
    "04:30",
    "05:00",
    "05:30",
    "06:00",
    "06:30",
    "07:00",
    "07:30",
    "08:00",
  ],
  token: function () {
    return (
      this.rizevo_login_data?.data?.token.type +
      " " +
      this.rizevo_login_data?.data?.token.access_token
    );
  },
  headers: function () {
    return { ...headers, Authorization: this.token() };
  },
  postOptions: function () {
    return {
      ...postOptions,
      headers: { ...postOptions.headers, Authorization: this.token() },
    };
  },
  getOptions: function () {
    return {
      ...getOptions,
      headers: { ...getOptions.headers, Authorization: this.token() },
    };
  },
};

const resetState = initalState;
window.resetState = resetState;

function Reducer(state = initalState, action) {
  switch (action.type) {
    case "GET_LOCATIONS": {
      return Object.assign({}, state, { locations: action.data });
    }
    case "GET_OPENING_HOURS": {
      return { ...state, ...action.data };
    }
    case "GET_BUSINESS_CATEGORIES": {
      return Object.assign({}, state, { businessCatergories: action.data });
    }
    case "UNAUTHORIZED": {
      return Object.assign({}, state, { rizevo_login_data: action.data });
    }
    case "GET_PROFILE": {
      return Object.assign({}, state, { userProfile: action.data });
    }
    case "LOGIN_DATA": {
      localStorage.setItem(
        "rizevo_login_data",
        JSON.stringify({ data: action.data.data })
      );
      return Object.assign({}, state, { rizevo_login_data: action.data });
    }
    case "GET_BUSINESS": {
      return Object.assign({}, state, { business: action.data });
    }
    case "GET_MEMBER": {
      return Object.assign({}, state, {
        member: { ...action.data },
      });
    }
    case "GET_BANKS": {
      return Object.assign({}, state, { banks: action.data });
    }
    case "GET_BOOKING_SETTINGS": {
      return Object.assign({}, state, {
        bookingSettings: { ...action.data },
      });
    }
    case "LOG_OUT":
      // eslint-disable-next-line no-lone-blocks
      {
        localStorage.removeItem("rizevo_login_data");
        window.location.reload();
      }
      break;
    default: {
      return initalState;
    }
  }
  // return initalState;
}

const store = createStore(Reducer);

//getBanks...
API.get("banks", { headers: initalState.headers() }).then(({ data }) => {
  let new_data = data.data.banks;
  store.dispatch({ type: "GET_BANKS", data: new_data });
});


//get booking settings...
API.get("business/booking-settings", { headers: initalState.headers() }).then(
  ({ data }) => {
    store.dispatch({ type: "GET_BOOKING_SETTINGS", data: data.data });
  }
);

//get opening hours settings...
API.get("business/opening-hours", { headers: initalState.headers() }).then(
  ({ data: { data } }) => {
    store.dispatch({ type: "GET_OPENING_HOURS", data });
  }
);

//get resources that don't need auth
function getResource(resourcePath, action) {
  fetch(`${api}/${resourcePath}`, getOptions)
    .then((res) => res.json())
    .then((obj) => {
      const data = obj.data;
      store.dispatch({ ...action, data });
    });
}

getResource("locations", { type: "GET_LOCATIONS" });
getResource("business/types", { type: "GET_BUSINESS_CATEGORIES" });

export { store, rizevo_login_data };
